import {
  SMS_OPT_OUT_POLICY_HINT_TEXT
} from 'react/types/constants';

angular.module('gym.components').directive('contactMessageSender', function() {
  return {
    restrict: 'E',
    scope: {
      contact: '=',
      messageType: '=',
      messageParams: '=',
      reloadContact: '=',
      location: '@',
      close: '&'
    },
    template: require('templates/components/contacts/comms/contact_message_sender.html.slim'),
    controller: ["$scope", "$rootScope", "$stateParams", "$http", "$filter", "$timeout", "$q", "flash", "Templates", "ContactCommunicationService", "ConversationLogService", "SmsValidationService", "PushNotificationValidationService", "AssetLibraryService", "DefaultReplyAddressService", "TestEmailsService", "TemplateValidationService", "ConfirmLeaveUnsavedChangesService", "PushNotificationOptionsService", "ReactModal", function($scope, $rootScope, $stateParams, $http, $filter, $timeout, $q, flash, Templates, ContactCommunicationService, ConversationLogService, SmsValidationService, PushNotificationValidationService, AssetLibraryService, DefaultReplyAddressService, TestEmailsService, TemplateValidationService, ConfirmLeaveUnsavedChangesService, PushNotificationOptionsService, ReactModal) {
      var getAvailableChannel, getPlainContent, getPlainSubject, getRecipientsIds, initialTemplates, isContactUnsubscribed, loadPushNotificationRecipientInfo, loadSecondaryRecipients, loadTemplates, preselectRecipients, ref, ref1, registerListener, templatesCopy, typeLabel, unregisterListener;
      $scope.templates = [];
      $scope.recipients = [];
      initialTemplates = [];
      $scope.gym = $rootScope.gym;
      $scope.pushNotificationRoutes = [
        {
          label: "No preference (open app to Notifications list)",
          value: ''
        }
      ];
      $scope.loadPushNotificationRoutes = function() {
        return PushNotificationOptionsService.getOptions($scope.gym.id, {}).then(function(data) {
          if (data.length) {
            return $scope.pushNotificationRoutes = $scope.pushNotificationRoutes.concat(data);
          } else {
            return $scope.pushNotificationRoutes = data;
          }
        }).catch(function(error) {
          return flash.error(error);
        });
      };
      $scope.toggleAssetLibrary = function() {
        return AssetLibraryService.open({
          mode: 'select'
        }).then(function(asset) {
          $scope.template.selected.push_notification_image_asset_id = asset.id;
          $scope.template.selected.push_notification_image_url = asset.attached_url;
          return $scope.template.selected.push_notification_image_thumb_url = asset.thumb_url;
        });
      };
      $scope.removeImage = function() {
        $scope.template.selected.push_notification_image_asset_id = null;
        $scope.template.selected.push_notification_image_url = null;
        return $scope.template.selected.push_notification_image_thumb_url = null;
      };
      $scope.previewImage = function() {
        return ReactModal.open({
          component: 'PushNotificationImageModal',
          props: {
            imageUrl: $scope.template.selected.push_notification_image_url,
            replaceImage: $scope.toggleAssetLibrary,
            removeImage: $scope.removeImage
          }
        });
      };
      $scope.loadPushNotificationRoutes();
      $scope.smsHintText = SMS_OPT_OUT_POLICY_HINT_TEXT;
      $scope.isContactTab = function() {
        return $scope.location === 'tab';
      };
      $scope.setReplyAddress = function(email) {
        return $timeout(function() {
          return $scope.template.selected.reply_address = email;
        });
      };
      $scope.getSmsOptions = function(contactType) {
        if (contactType === 'prospect') {
          return $scope.prospectSmsOptions;
        } else if ($scope.messageParams === 'debtors_report' || contactType === 'member') {
          return $scope.membersSmsOptions;
        } else {
          return $scope.nacSmsOptions;
        }
      };
      $scope.resolveDefaultSmsOptionValue = function() {
        var ref, ref1, selectedPolicy;
        selectedPolicy = ((ref = $scope.template) != null ? (ref1 = ref.selected) != null ? ref1.sms_opt_out_instructions_policy : void 0 : void 0) || $scope.gym.presented_gym_sms_detail.sms_opt_out_instructions_policy;
        if ($scope.contact.type === 'prospect') {
          return 'add_sms_opt_out_instructions_for_prospects_only';
        } else if (selectedPolicy === 'add_sms_opt_out_instructions_for_all_contacts') {
          return 'add_sms_opt_out_instructions_for_all_contacts';
        } else if ((selectedPolicy === 'add_sms_opt_out_instructions_for_prospects_only' || selectedPolicy === 'add_sms_opt_out_instructions_for_prospects_and_cancelled_members_only') && $scope.contact.type !== 'member') {
          return 'add_sms_opt_out_instructions_for_prospects_only';
        } else if (selectedPolicy === 'add_sms_opt_out_instructions_for_prospects_and_cancelled_members_only') {
          return 'add_sms_opt_out_instructions_for_prospects_and_cancelled_members_only';
        } else {
          return 'add_sms_opt_out_instructions_for_prospects_only';
        }
      };
      $scope.prospectSmsOptions = [
        {
          label: "Add opt-out instructions to message (required for Prospects)",
          value: "add_sms_opt_out_instructions_for_prospects_only"
        }
      ];
      $scope.nacSmsOptions = [
        {
          label: "Add opt-out instructions to message",
          value: "add_sms_opt_out_instructions_for_all_contacts"
        },
        {
          label: "Do not add opt-out instructions to message",
          value: "add_sms_opt_out_instructions_for_prospects_only"
        }
      ];
      $scope.membersSmsOptions = [
        {
          label: "Add opt-out instructions to all messages",
          value: "add_sms_opt_out_instructions_for_all_contacts"
        },
        {
          label: "Add opt-out instructions for messages sent to cancelled Members only",
          value: "add_sms_opt_out_instructions_for_prospects_and_cancelled_members_only"
        },
        {
          label: "Do not add opt-out instructions to messages",
          value: "add_sms_opt_out_instructions_for_prospects_only"
        }
      ];
      $scope.listenerRegistered = false;
      registerListener = function() {
        if ($scope.listenerRegistered) {
          return;
        }
        $rootScope.$$listeners['send_message:request_close'] = [
          function(event) {
            return $scope.onClose();
          }
        ];
        return $scope.listenerRegistered = true;
      };
      unregisterListener = function() {
        if ($scope.listenerRegistered) {
          delete $rootScope.$$listeners['send_message:request_close'];
          return $scope.listenerRegistered = false;
        }
      };
      registerListener();
      $scope.onClose = function(skipConfirmation) {
        if ($scope.close) {
          if ($scope.displayConfirmationOnClose && !skipConfirmation) {
            return $scope.openConfirmationModal();
          } else {
            return $scope.close();
          }
        }
      };
      $scope.openConfirmationModal = () => {
        return ReactModal.open({
          component: 'CloseUnsavedFormModal',
          props: {
            title: 'Close drawer',
            text: 'Are you sure? This will abandon any unsaved changes.',
            cancel: () => {
              $scope.displayConfirmationOnClose = false;
              return $scope.close();
            }
          }
        });
      };
      if (!$scope.isContactTab()) {
        ConfirmLeaveUnsavedChangesService.watch($scope, 'template', {
          closeModal: function() {
            return $scope.onClose(true);
          }
        });
      }
      loadPushNotificationRecipientInfo = function() {
        var deferred, url;
        deferred = $q.defer();
        if ($scope.gym.mobile_app_enabled) {
          url = `/gyms/${$scope.gym.id}/mobile_app/push_notification_recipients/list`;
          $http.post(url, {
            filters: {
              contact_ids: [$scope.contact.id]
            }
          }).then(function(response) {
            return deferred.resolve(response.data.collection[0]);
          });
        } else {
          deferred.resolve(void 0);
        }
        return deferred.promise;
      };
      $scope.pushNotificationsEnabled = function() {
        var ref, ref1, ref2;
        return $scope.gym.mobile_app_enabled && (((ref = $rootScope.mobileAppMeta) != null ? ref.push_notifications_feature_enabled : void 0) || $scope.gym.push_notifications_feature_enabled) && (((ref1 = $scope.pushNotificationRecipient) != null ? ref1.push_notification_status : void 0) === 'notifiable' || ((ref2 = $scope.pushNotificationRecipient) != null ? ref2.push_notification_status : void 0) === 'access_disabled');
      };
      templatesCopy = function() {
        return initialTemplates.map(function(template) {
          return angular.extend({}, template);
        });
      };
      loadTemplates = function() {
        var params;
        params = {
          count: 1500,
          'filters[for_general_use]': true
        };
        $scope.isTemplatesLoading = true;
        return Templates.getList(params).then(function(templates) {
          $scope.isTemplatesLoading = false;
          initialTemplates = templates.plain();
          $scope.templates = templatesCopy();
          return $timeout(function() {
            return $scope.displayConfirmationOnClose = false;
          });
        });
      };
      preselectRecipients = function() {
        return $scope.recipients.map(function(item) {
          var available;
          available = (function() {
            switch ($scope.template.selected.channel) {
              case 'sms':
                return item.sms_status === 'sms_accepted' && !item.unsubscribed_from_sms && !!item.recipient_phone_number;
              case 'email':
                return item.email_status === 'email_accepted' && !item.unsubscribed_from_email && !!item.recipient_email;
              case 'push_notification':
                return $scope.pushNotificationsEnabled();
            }
          })();
          item.selected = available;
          item.available = available;
          return item;
        });
      };
      loadSecondaryRecipients = function() {
        var params, promises, recipientLimit, url;
        url = `/gyms/${$stateParams.gymId}/contact_comms_recipients`;
        recipientLimit = $scope.gym.gym_config.bulk_comms_recipient_limit;
        params = {
          'filters[contact_ids][]': [$scope.contact.id],
          count: recipientLimit
        };
        promises = [
          $http.get(url,
          {
            params: params
          }),
          loadPushNotificationRecipientInfo()
        ];
        return $q.all(promises).then(function(response) {
          $scope.pushNotificationRecipient = response[1];
          $scope.recipients = response[0].data.collection.map(function(item) {
            item.name = item.name || item.family_member_name || item.contact_name;
            item.unsubscribed_from_email = item.email_status === 'email_unsubscribed';
            item.unsubscribed_from_sms = item.sms_status === 'sms_unsubscribed';
            item.contact_id = item.for_primary_contact ? item.contact_id : item.family_member_id;
            item.contact_type = item.for_primary_contact ? item.contact_type : item.family_member_type;
            return item;
          });
          return preselectRecipients();
        });
      };
      loadTemplates();
      loadSecondaryRecipients();
      $scope.isContactUnsubscribed = isContactUnsubscribed = function(recipient) {
        if ($scope.template.selected.channel === 'email') {
          return recipient.unsubscribed_from_email || !recipient.recipient_email;
        } else {
          return recipient.unsubscribed_from_sms || !recipient.recipient_phone_number;
        }
      };
      getAvailableChannel = function() {
        var channel, unsubscribed_from_email, unsubscribed_from_sms, unsubscribes;
        unsubscribes = $scope.contact.unsubscribes;
        unsubscribed_from_email = unsubscribes.unsubscribed_from_email;
        unsubscribed_from_sms = unsubscribes.unsubscribed_from_sms;
        if ($scope.messageType) {
          return $scope.messageType;
        }
        channel = (function() {
          var ref, ref1;
          switch (false) {
            case !(!unsubscribed_from_email && !unsubscribed_from_sms):
              return ((ref = $scope.template) != null ? (ref1 = ref.selected) != null ? ref1.channel : void 0 : void 0) || 'email';
            case !(unsubscribed_from_sms && !unsubscribed_from_email):
              return 'email';
            case !(unsubscribed_from_email && !unsubscribed_from_sms):
              return 'sms';
            case !$scope.pushNotificationsEnabled():
              return 'push_notification';
            default:
              return 'email';
          }
        })();
        return channel;
      };
      $scope.updateChannel = function() {
        var base, ref, ref1;
        (base = $scope.template).selected || (base.selected = {});
        $scope.template.selected.key = Math.floor(Math.random() * 1000000);
        $scope.template.selected.channel = $scope.template.selected.channel || 'email';
        $scope.template.selected.reply_address = DefaultReplyAddressService.getDefaultEmail();
        $scope.template.selected.sms_opt_out_instructions_policy = $scope.resolveDefaultSmsOptionValue();
        if (((ref = $scope.template) != null ? (ref1 = ref.selected) != null ? ref1.push_notification_route_name : void 0 : void 0) === null && $scope.pushNotificationRoutes.length > 0) {
          $scope.template.selected.push_notification_route_name = $scope.pushNotificationRoutes[0].value;
        }
        preselectRecipients();
        return $timeout(function() {
          return $scope.displayConfirmationOnClose = false;
        });
      };
      $scope.onChannelChange = function() {
        return preselectRecipients();
      };
      $scope.template = {
        selected: {
          channel: getAvailableChannel(),
          reply_address: DefaultReplyAddressService.getDefaultEmail(),
          sms_opt_out_instructions_policy: $scope.resolveDefaultSmsOptionValue(),
          push_notification_route_name: ((ref = $scope.template) != null ? ref.selected.push_notification_route_name : void 0) || $scope.pushNotificationRoutes[0].value,
          push_notification_image_asset_id: (ref1 = $scope.template) != null ? ref1.selected.push_notification_image_asset_id : void 0
        }
      };
      $scope.submitTemplate = function(template) {
        $scope.isLoading = true;
        if (template.push_notification_route_name === '') {
          template.push_notification_route_name = null;
        }
        if ('push_notification_image_url' in template) {
          delete template.push_notification_image_url;
        }
        if ('push_notification_image_thumb_url' in template) {
          delete template.push_notification_image_thumb_url;
        }
        return ContactCommunicationService.send($scope.gym.id, $scope.contact.id, template, getRecipientsIds()).then(function() {
          flash.success = 'The message was sent';
          $scope.isLoading = false;
          $scope.templates = templatesCopy();
          $scope.template = {};
          $scope.updateChannel();
          return $scope.onClose(true);
        }, function(error) {
          flash.error = error;
          return $scope.isLoading = false;
        });
      };
      $scope.sendTemplate = function(template) {
        return $scope.submitTemplate(template);
      };
      getRecipientsIds = function() {
        return $scope.recipients.filter(function(item) {
          return item.selected;
        }).map(function(item) {
          return item.id;
        });
      };
      $scope.isFreemiumWithoutPaymentMethod = function() {
        return $scope.template.selected.channel === 'sms' && $scope.gym.on_freemium && !$scope.gym.subscription_payment_method_present && $scope.gym.sms_enabled;
      };
      $scope.phoneNumberInvalid = function() {
        var template;
        template = $scope.template.selected;
        return template.channel === 'sms' && !getRecipientsIds().length;
      };
      getPlainSubject = function(subject) {
        return $filter('sanitizeEditorField')(subject || '', true, {
          target: 'subject'
        });
      };
      getPlainContent = function(content) {
        return $filter('sanitizeEditorField')(content || '', true);
      };
      $scope.isMessageReady = function(template) {
        var contentValid, subjectValid;
        if (!getRecipientsIds().length) {
          return false;
        }
        if (template.requires_object || $scope.isLoading) {
          return false;
        }
        $scope.error = SmsValidationService.getErrors(template);
        if ($scope.error) {
          return false;
        }
        if (template && template.channel) {
          subjectValid = TemplateValidationService.subjectIsNotEmpty(template.subject);
          contentValid = TemplateValidationService.contentIsNotEmpty(template.content);
          switch (template.channel) {
            case 'email':
              return contentValid && subjectValid && $scope.gym.custom_emails_enabled;
            case 'push_notification':
              return contentValid && subjectValid && $scope.pushNotificationsEnabled() && PushNotificationValidationService.isLengthValid(template.content);
            default:
              return $scope.gym.sms_enabled && contentValid && SmsValidationService.isLengthValid(template.content) && !$scope.isFreemiumWithoutPaymentMethod();
          }
        }
      };
      $scope.sendUnavailable = function() {
        return $scope.recipients.length && !_.find($scope.recipients, function(item) {
          return item.available;
        });
      };
      typeLabel = function() {
        switch ($scope.template.selected.channel) {
          case 'email':
            return 'Emails';
          case 'sms':
            return 'SMSes';
          case 'push_notification':
            return 'Push Notification';
        }
      };
      $scope.sendButtonLabel = function() {
        if ($scope.sendUnavailable()) {
          return `Unable to send: contact does not accept ${typeLabel()}`;
        } else {
          return "Send";
        }
      };
      $scope.testEmailReady = function() {
        return $scope.template.selected.channel === 'email' && $scope.gym.custom_emails_enabled && $scope.isMessageReady($scope.template.selected);
      };
      return $scope.sendTestEmail = function() {
        var params;
        params = {
          subject: $scope.template.selected.subject,
          content: $scope.template.selected.content,
          head_tag_content: $scope.template.selected.head_tag_content,
          reply_address: window.currentUser.email,
          contact: $scope.contact
        };
        return TestEmailsService.sendTestEmail(params);
      };
    }]
  };
});
